import { useEffect, useState } from 'react';
import useBaseRequest from '../../api/BaseRequest';
import { IGroupSeason } from '@grassrootly/api';
import { GetGroupSeasons } from '@grassrootly/api/providers/supabase-provider/actions';
import { GetGroupSeasonsPayload } from '@grassrootly/api';

export interface SeasonOption {
  value: number;
  label: string;
  icon?: string;
  organizationId?: number | null;
}

export function useSeasonSelector(groupId: number | undefined) {
  const [seasonOptions, setSeasonOptions] = useState<SeasonOption[]>([]);
  const [selectedSeasonId, setSelectedSeasonId] = useState<number | undefined>(undefined);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState<number | null>(null);

  const { loading: loadingSeasons, execute: getGroupSeasons } = useBaseRequest(GetGroupSeasons, {
    onCompleted: async (data: IGroupSeason[]) => {
      // Filter only active seasons
      const activeSeasons = data.filter(season => season.season_is_active);
      
      const options = activeSeasons
        .map(season => ({
          value: season.season_id,
          label: season.season_summary,
          icon: season.organization_logo || undefined,
          organizationId: season.organization_id
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      
      setSeasonOptions(options);
      
      // No auto-selection - season is optional
    },
  });

  // Fetch seasons when group changes
  useEffect(() => {
    if (groupId) {
      const params: GetGroupSeasonsPayload = {
        groupId: groupId,
      };
      getGroupSeasons(params);
    }
  }, [groupId]);

  // Update organization ID when season changes
  const handleSeasonChange = (seasonId: number | undefined) => {
    setSelectedSeasonId(seasonId);
    if (seasonId) {
      const selectedSeason = seasonOptions.find(option => option.value === seasonId);
      setSelectedOrganizationId(selectedSeason?.organizationId || null);
    } else {
      setSelectedOrganizationId(null);
    }
  };

  return {
    seasonOptions,
    selectedSeasonId,
    setSelectedSeasonId: handleSeasonChange,
    selectedOrganizationId,
    loadingSeasons,
  };
}
